import { ActionButton, ActionButtonDefinition } from "components/actionButton/actionButton";
import {
    Action,
    ActionDefinition,
    FieldParameterMapping,
    isParameterizedActionDefinition,
    isServerActionDefinition,
    isTableActionDefinition,
    ServerActionDefinition,
} from "components/actions/actions";
import appModuleRegistry from "components/appModules/appModuleRegistry";
import { ButtonBar } from "components/buttonBar/buttonBar";
import {
    ActionComponentDefinition,
    AutoValueComponent,
    BindableComponent,
    BindableComponentDefinition,
    Component,
    DataAppendableComponent,
    DataHolderComponent,
    DisableableComponent,
    isPostRenderedComponent,
    isValidationStatusComponent,
    NeedsUnhideComponent,
    NestedComponentContainer,
    PostRenderedComponent,
} from "components/components/Component";
import { listenDataUpdateRequest } from "components/components/componentUpdateRequestedUtil";
import { ComponentActionEventDetail, ComponentActionHelper } from "components/events/componentActionHelper";
import { DataChangedEventDetail, fireDataChangedCleared, fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { Form, FormDefinition } from "components/form/form";
import i18n from "components/i18n/i18n";
import { Dictionary, Optgroup, Option, TableOptions } from "components/input/select/options";
import * as message from "components/message/message";
import { Renderer } from "components/Renderer";
import { RestrictionAttribute, TableRestrictions } from "components/restrictions/Restrictions";
import { ColumnDefinition } from "components/table/columns/ColumnDefinitions";
import sislogUserGlobals from "components/UserGlobals";
import "datatables.net";
import "datatables.net-fixedcolumns";
import "datatables.net-scroller";
import $ from "jquery";
import { HeaderSelectCheckElement as HeaderSelectCheckElement, initCheckHeaderWebComponent } from "./checkHeader/checkHeader";
import { CheckInfoElement, initTableCheckInfoWebComponent } from "./checkInfo/checkInfo";
import { CheckColumnDefinition, isCheckColumnDefinition } from "./columns/CheckColumn";
import { ColumnFactory } from "./columns/ColumnFactory";
import { isComponentColumnDefinition } from "./columns/ComponentColumn";
import { ComponentCells } from "./componentCellRenderer";
// import "lib/datatables/ColReorderWithResize.js";
import "./datatables.scrollResize.js";
import { DataTableUtils } from "./dataTableUtils";
import TableExport, { ExportConfiguration } from "./export";
import { TableRestrictionDataModel } from "./columns/data/tableRestrictionDataModel";
import { AdditionDataChangedEventDetail, TableAdditionInline } from "./footer/tableAdditionInline";
import { FooterCellDefinition, TableFooter } from "./footer/tableFooter";
import { Paginator } from "./paginator";
import { RowKey } from "./rowKey";
import { ScrollPosition } from "./scrollPosition";
import "./style/table.scss";
import { TableDefinitionUtils } from "./tableDefinitionUtils";
import { TableModel } from "./tableModel";
import { TableRestrictionsImpl } from "./tableRestrictions";
import { TableStatus } from "./tableStatus";
import { isTableUpdateData, TableUpdateData } from "./tableUpdateData";
import { OnVisibleRunner } from "components/pages/embeddedPage/OnVisibleRunner";
import { DataCellComponent } from "./columns/data/dataCellComponent";
import isEqual from "lodash/isEqual";
import { isCheckBoxDefinition, CheckboxDefinition } from "components/table/columns/CheckColumn";

initCheckHeaderWebComponent();
initTableCheckInfoWebComponent();

export class Table implements
    Component,
    DataHolderComponent,
    AutoValueComponent,
    NeedsUnhideComponent,
    DataAppendableComponent,
    BindableComponent,
    DisableableComponent,
    TableRestrictionApplicable,
    NestedComponentContainer {
    public componentType = "table";
    public definition: TableDefinition;
    public id: string;
    public view: HTMLElement;
    private jqueryView: JQuery;
    private tableView: JQuery;
    private tableHolderView: JQuery;
    public dataTable: DataTables.Api;
    private filterComponent: Form;
    private buttonBar: ButtonBar;
    private paginator: Paginator;
    public rowKey: RowKey;
    private model = new TableModel();
    private scrollPosition: ScrollPosition;
    private componentCells: ComponentCells;
    private restrictionsDataModel: TableRestrictionDataModel;
    public restrictions = new TableRestrictionsImpl();
    public columnOptions: Dictionary<Array<Option | Optgroup>>;
    public status = new TableStatus(this.model);
    public dataColumns: ColumnDefinition[] = [];
    public columnSettings: DataTables.ColumnDefsSettings[];
    public tableAdditionManager: TableAdditionInline;

    constructor(schema: TableDefinition) {
        this.definition = schema;
        this.definition.extraFields = this.definition.extraFields || [];
        this.definition.idColumns = this.definition.idColumns || [];
        this.id = this.definition.id;
        this.rowKey = new RowKey(this.definition);
        this.dataColumns = TableDefinitionUtils.getDataColumns(schema);
        this.restrictionsDataModel = new TableRestrictionDataModel(schema);
        this.prepareColumnOptions(this.definition);
    }

    private updateModelAllCheckboxColumn(idxColumn: number, isChecked: boolean) {
        this.model.getColumn(idxColumn).forEach((cellDataModel, i) => {
            //Si es boolean o CheckBoxDefinition es una celda de checkbox
            if (cellDataModel || isCheckBoxDefinition(cellDataModel)) {
                //TODO EVO1
                if (isCheckBoxDefinition(cellDataModel)) {
                    const checkBoxDataModel = (cellDataModel as CheckboxDefinition);
                    if (!checkBoxDataModel.disabled) {
                        checkBoxDataModel.checked = isChecked;
                    }
                } else {
                    cellDataModel = isChecked;
                }
            }
        });
    }

    //#region callback methods
    private manageCheckAll = (evt: CustomEvent) => {
        const idx = TableDefinitionUtils.getColumnIndexForProperty(evt.detail.property, this.definition);
        const status = this.status.clickHeaderCheckbox(evt.detail.property, idx, this.rowKey).status;
        const column = this.dataTable.column(idx);
        const columnDef = DataTableUtils.getColumnDefsSettings(this.dataTable, idx);
        if (status === "all-checked") {
            (column.nodes() as any).each((n) => {
                const node = $(n).find("input:not(:disabled):not(:checked)")[0];
                if (node != null) {
                    (node as HTMLInputElement).checked = true;
                    this.applyRowStyleOnCheckClick(
                        node as HTMLInputElement,
                        columnDef);
                }
            });
            this.updateModelAllCheckboxColumn(idx, true);
        }

        if (status === "none-checked") {
            (column.nodes() as any).each((n) => {
                const node = $(n).find("input:not(:disabled):checked")[0];
                if (node != null) {
                    (node as HTMLInputElement).checked = false;
                    this.applyRowStyleOnCheckClick(
                        node as HTMLInputElement,
                        columnDef);
                }
            });
            this.updateModelAllCheckboxColumn(idx, false);
        }
        (evt.target as HeaderSelectCheckElement).status = status;
        fireDataChangedEvent(this, this.view, this.getValue(), undefined, this.status.isValid());
        this.checkActionsStatus();
        (this.view.querySelector("table-check-info") as CheckInfoElement).info = this.status.checkedInfo;


        const checkColumn = this.definition.columns[idx] as CheckColumnDefinition;
        for (const actionEvent of checkColumn.eventActions ?? []) {
            evt.target.dispatchEvent(new CustomEvent(
                "componentActionEvent",
                {
                    bubbles: true,
                    detail: {
                        action: actionEvent,
                    },
                }));
        }
    }

    private updateCheckedModel = (evt: JQuery.TriggeredEvent) => {
        const cell = this.getCellFromEvt(evt);
        const rowIndex = this.getRowIndexFromCell(cell);
        const rowKey = this.getRowKey(rowIndex);
        const columnIndex = this.dataTable.cell(cell).index().column;
        this.model.setCell(rowIndex, columnIndex, (evt.target as HTMLInputElement).checked);
        this.applyRowStyleOnCheckClick(
            evt.target as HTMLInputElement,
            DataTableUtils.getColumnDefsSettings(this.dataTable, columnIndex));
        const columnProperty = DataTableUtils.getColumnProperty(this.dataTable, columnIndex);

        this.status.setChecked(columnProperty, rowKey, this.model.getRow(rowIndex), (evt.target as HTMLInputElement).checked);
        const columnCheckStatus = this.status.calculateCheckHeaderStatus(columnProperty, columnIndex);

        this.updateHeaderCheckOnRowCheck(columnProperty, columnCheckStatus);

        fireDataChangedEvent(this, this.view, this.getValue(), undefined, this.status.isValid());
        this.checkActionsStatus();
        (this.view.querySelector("table-check-info") as CheckInfoElement).info = this.status.checkedInfo;

        const checkColumn = this.definition.columns[columnIndex] as CheckColumnDefinition;
        for (const actionEvent of checkColumn.eventActions ?? []) {
            evt.target.dispatchEvent(new CustomEvent(
                "componentActionEvent",
                {
                    bubbles: true,
                    detail: {
                        action: actionEvent,
                    },
                }));
        }
    }

    private updateHeaderCheckOnRowCheck(columnProperty, columnCheckStatus) {
        const headerCheck = this.view.querySelector("table-check-header[property=" + columnProperty + "]");
        (headerCheck as any).status = columnCheckStatus.status;
    }

    private applyRowStyleOnCheckClick(checkbox: HTMLInputElement, cd): void {
        if (cd.definition.rowStyle == null) {
            return;
        }
        if (checkbox.checked) {
            $(checkbox).closest("tr").addClass("c-table__row--" + cd.definition.rowStyle);
        } else {
            $(checkbox).closest("tr").removeClass("c-table__row--" + cd.definition.rowStyle);
        }
    }

    private getButtons() {
        if (this.buttonBar == null) {
            return [];
        }
        return this.buttonBar.getButtons();
    }

    private checkActionsStatus() {
        const buttons = this.getButtons();
        for (const button of buttons) {
            if (button.definition.action != null) {
                let enableWithoutTableData = true;
                let existsColumnCheckTable = false;
                let anyChecked = false;
                if (isTableActionDefinition(button.definition.action)) {
                    enableWithoutTableData = button.definition.action?.enableWithoutTableData ?? true;
                    existsColumnCheckTable = button.definition.action?.column !== undefined ?? false;
                    anyChecked = this.status.isAnyChecked(button.definition.action.column);
                }

                if (this.isButtonEnabled(
                    this.status.disabled ?? false,
                    button.definition.action.actionName?.startsWith("unstackStackedPage"),
                    button.definition.action.actionName?.startsWith("export-"),
                    button.definition.action.needsChange,
                    button.definition.action.needsValid,
                    this.status.changed,
                    this.status.isValid(),
                    existsColumnCheckTable,
                    enableWithoutTableData,
                    anyChecked
                )) {
                    button.enable();
                } else {
                    button.disable();
                }
            }
        }
    }

    private isButtonEnabled(
        tableIsDisabled: boolean,
        isUnstackAction: boolean,
        isExportAction: boolean,
        actionRequiresChange: boolean,
        actionRequiresValid: boolean,
        dataIsChanged: boolean,
        dataIsValid: boolean,
        existsColumnCheckTable: boolean,
        enableWithoutTableData: boolean,
        anyRecordIsChecked: boolean,

    ) {
        if (isUnstackAction || isExportAction) {
            //La eprotacion a excel solo cndo haya datos
            if (isExportAction) {
                return (this.model.recordsTotal !== 0);
            }
            return true;
        }
        if (tableIsDisabled) {
            return false;
        }

        if (actionRequiresChange && !dataIsChanged && !anyRecordIsChecked) {
            return false;
        }
        if (actionRequiresValid && !dataIsValid) {
            return false;
        }

        if (enableWithoutTableData) {
            return true;
        } else {
            if ((this.model.recordsTotal !== 0) &&
                ((!existsColumnCheckTable)
                    || (existsColumnCheckTable && anyRecordIsChecked))) {
                return true;
            } else {
                return false;
            }
        }
    }

    private manageRowActionClick = (evt: JQuery.TriggeredEvent) => {
        const cell = $(evt.target).closest("td");
        const actionDefinition = (this.getColumnAction(this.dataTable, this.dataTable.cell(cell).index().column));
        const action = new Action(actionDefinition, this);
        const rowData = this.dataTable.row(cell).data();
        let data = {};

        if (isServerActionDefinition(action.definition)) {
            if (action.definition.fieldParameterMappings != null) {
                $.each(action.definition.fieldParameterMappings, (key, mapping) => {
                    data[mapping.as] = this.getValueForFieldInRow(mapping.field, rowData);
                    if (mapping.field.startsWith("filter.")) {
                        data[mapping.as] = this.filterComponent.currentData[mapping.field.substring(7)];
                    }
                });
            }
            if (action.definition.mapAll) {
                data = this.mapToColumns(rowData);
            } else if (action.definition.fieldParameterMappings == null) {
                for (let id of this.definition.idColumns) {
                    data[id] = this.getValueForFieldInRow(id, rowData);
                }
            }
        } else {
            data = this.mapToColumns(rowData);

        }
        action.run(data, this);
    }

    private mapToColumns(rowData: object | any[]) {
        return TableDefinitionUtils.rowDataToObject(this.definition, rowData);
    }

    private getColumnAction(dataTable, idx: number) {
        let name = null;
        $.each(dataTable.settings().init().columnDefs, (key, val) => {
            if (val.targets === idx) {
                name = val.definition.action;
                return;
            }
        });
        return name;
    }
    //#endregion

    //#region Render methods
    public render(): Element {
        this.renderTemplate();
        this.renderActions();
        this.bindEventsOnRender();
        return this.view;
    }

    private renderTemplate() {
        // col-xs-{{width}} {{#if mdwidth}} col-md-{{mdwidth}}{{/if}}
        const containerTag = '<div class="c-table" id="' + this.definition.id + '" data-s6-id="' + this.definition.id + '" >';
        const innerTag = '<div class="c-table__inner col-xs-' + this.definition.width + '" >';
        this.jqueryView = $(containerTag);
        this.view = this.jqueryView[0];
        $(innerTag).appendTo(this.view);
        let tableTag = '<div class="c-table__table';
        if (this.definition.noEmptyMessage) {
            tableTag += " no-empty-message";
        }
        tableTag += '">';
        this.tableHolderView = $(tableTag);
        this.tableView = $('<table class="display datatable norendered" style="width: 100%">');
        this.renderFilter();
        this.renderHeader();
        TableFooter.renderFooter(this.tableView, this.definition, this, this.restrictionsDataModel);
    }

    private renderFilter() {
        if (this.definition.filter == null) {
            return;
        }
        this.definition.filter.preventLoss = false;
        this.filterComponent = Renderer.instance().build(this.definition.filter) as Form;
        if (this.filterComponent == null) {
            console.warn("no filter component created for definition", this.definition.filter);
            return;
        }
        const parentUpdateData = this.filterComponent.updateData;
        this.filterComponent.updateData = (data: any): void => {
            if (data != null && data.recordsTotal != null) {
                this.scrollPosition.top();
                this.updateData(data);
                if (this.definition.collapseFilterAfterSearch && data.recordsTotal > 0) {
                    this.filterComponent.collapse();
                }
            } else {
                if (data != null && this.restrictionsDataModel?.parentData != null && this.definition.property != null) {
                    data["_parent_"] = { ...this.restrictionsDataModel.parentData };
                    delete data["_parent_"][this.definition.property];
                }
                parentUpdateData(data);
            }
        };
        const filterContainer = $('<div class="c-table__filter row">');
        const filterNode = Renderer.instance().render(this.filterComponent);
        const filterView = $(filterNode) as JQuery<HTMLElement>;
        filterView.appendTo(filterContainer);
        filterContainer.appendTo(this.jqueryView.children(".c-table__inner"));

        filterContainer[0].addEventListener("formUndoRequested", (evt: CustomEvent) => {
            evt.stopPropagation();
            const event = new CustomEvent("askForChangeConfirmation", {
                bubbles: true,
                detail: {
                    componentHolder: this,
                    callback: evt.detail.undo,
                },
            });
            document.dispatchEvent(event);
        });

        filterView[0].addEventListener("formUndoed", () => {
            this.model.resetFilterData(this.filterComponent?.currentData);
            this.updateData(null);
            this.scrollPosition.top();
        });
    }

    private renderHeader() {
        const tableHeadView = $("<thead>");
        const tableHeadRowView = $("<tr>");
        const tableHeadRow2View = $("<tr>");
        tableHeadRowView.appendTo(tableHeadView);
        let groupedCols = false;
        this.definition.columns.forEach((val) => {
            if (val.type === "ColumnGroup") {
                groupedCols = true;
                tableHeadRow2View.appendTo(tableHeadView);
            }
        });
        tableHeadView.appendTo(this.tableView);
        this.tableView.appendTo(this.tableHolderView);
        this.tableHolderView.appendTo(this.jqueryView.children(".c-table__inner"));
        this.definition.columns.forEach((v) => $(this.renderHeaderCell(v, groupedCols)).appendTo(tableHeadRowView));
        if (groupedCols) {
            this.definition.columns.forEach((val) => {
                if (val.type === "ColumnGroup") {
                    val.columns.forEach((val2) => {
                        if (val2.tooltipKey != null) {
                            $('<th title="' + i18n.instance.t(val2.tooltipKey) + '">' + i18n.instance.t(val2.key) + "</th>")
                                .appendTo(tableHeadRow2View);
                        } else {
                            $("<th>" + i18n.instance.t(val2.key) + "</th>").appendTo(tableHeadRow2View);
                        }
                    });
                }
            });
        }
    }

    private renderHeaderCell = (val, groupedCols): string => {
        let html = "<th";
        if (val.tooltipKey != null) {
            html += ' title="' + i18n.instance.t(val.tooltipKey) + '"';
        }
        if (groupedCols) {
            if (val.type !== "ColumnGroup") {
                html += ' rowspan="2"';
            } else {
                html += ' class="column-group" colspan="' + val.columns.length + '"';
            }
        }
        html += ">" + i18n.instance.t(val.key);
        if (val.type === "CheckColumn") {
            html += "<table-check-header " +
                "property=" + val.property +
                " canSelectByCriteria=" + val.canSelectByCriteria + "></table-check-header>";
        }
        html += "</th>";
        return html;
    }

    private renderActions() {
        if ((this.definition.actions == null || this.definition.actions.length === 0)
            && (this.definition.exportConfigurations == null || this.definition.exportConfigurations.length === 0)) {
            return;
        }
        const barDefinition = {
            componentType: "buttonBar",
            id: "button-bar-" + this.id,
            children: this.definition.actions,
        };
        this.renderExportActions(barDefinition);
        const barContainer = $('<div class="c-table__actions row">');
        this.buttonBar = Renderer.instance().build(barDefinition) as ButtonBar;
        $(Renderer.instance().render(this.buttonBar)).appendTo(barContainer);
        this.buttonBar.children.forEach(((button) => {
            const actionButton = (button as ActionButton);
            actionButton.bindDataHolder(this);
        }));
        barContainer.appendTo(this.jqueryView.children(".c-table__inner"));
    }

    private renderExportActions(barDefinition) {
        TableExport.renderExportActions(this.definition, barDefinition);
    }

    private bindEventsOnRender() {
        this.tableView.on("click", "input.js-table-selector", this.updateCheckedModel);
        this.tableView.on("click", "a.icon", this.manageRowActionClick);
        $(this).on("parentRefreshNeeded", () => {
            fireDataChangedCleared(this.definition.id, this.view);
            this.refreshData();
        });

        this.tableHolderView[0].addEventListener("tableCheckHeaderClicked", this.manageCheckAll);
        this.tableHolderView[0].addEventListener("additionDataChanged", this.additionDataChangedCallback);
        this.tableView[0].addEventListener("dataChanged", this.dataChangedCallback);
        this.view.addEventListener(
            "clearDataCommitRequested",
            () => fireDataChangedCleared(this.definition.id, this.view));

        this.tableView[0].addEventListener("dataChangeRequest", this.dataChangeRequestCallback);
        this.view.addEventListener("tableDataUpdateRequested", this.tableDataUpdateRequestedCallback);

        // Ignore change events from the filter
        this.filterComponent?.view.addEventListener("dataChanged", (e) => e.stopPropagation());

        ComponentActionHelper.register(this);
        listenDataUpdateRequest(this);

        this.view.addEventListener("componentActionEvent", (event: CustomEvent<ComponentActionEventDetail>) => {
            event.stopPropagation();
            let rowData: any[];
            let index: number;
            const cell = this.getCellFromEvt(event);
            if (cell.length === 0) {
                rowData = null;
            } else {
                index = this.getRowIndexFromCell(cell);
                rowData = this.model.getRow(index);
            }
            const data = {
                rowData,
            };
            if (isServerActionDefinition(event.detail.action.action) && event.detail.action.action.submitsTableData === true) {
                data["tableData"] = this.selectDataForAction(event.detail.action.action);
            }

            // We need to combine the input components of the component columns with a new kind of component that backs a data colum (TextColumn, NumberColumn, DateColumn)

            // This can also be fired when the check all checkbox is clicked. In that case there will be not components for the dataholder.
            const cellElement = this.getCellFromEvt(event)[0];
            let dataholder = null;
            if (cellElement != null) {
                let id = event.detail.action.action.actionName + "-" + index;
                if (isServerActionDefinition(event.detail.action.action) && event.detail.action.action.rowLevelQueue === false) {
                    id = event.detail.action.action.actionName;
                }
                dataholder = this.restrictionsDataModel.rowDataHolder(
                    [
                        ...this.componentCells.getRowComponents(this.getCellFromEvt(event)[0]),
                        ...DataCellComponent.dataCellComponents(this.columnSettings, cell[0])
                    ],
                    rowData,
                    id
                )
            }
            new Action(event.detail.action.action, this).run(data, dataholder);
        });
    }
    //#endregion

    public getValueForFieldInRow(fieldName: string, row) {
        let position = this.dataColumns.findIndex((column) => column.property === fieldName);
        if (position < 0) {
            position = this.definition.extraFields.indexOf(fieldName);
            position += this.dataColumns.length;
        }
        return row[position];
    }

    public postRender(): Node {
        if (this.status.isCreated) {
            // The modal selector has not yet created the table at this point.
            if (this.status.isClientType()) {
                this.dataTable.columns.adjust().draw();
            }
            (this.dataTable as any).scroller.measure();
        }
        if (this.buttonBar != null) {
            this.buttonBar.children.forEach(((button) => {
                const actionButton = (button as ActionButton);
                actionButton.postRender();
            }));
        }
        if (this.filterComponent != null) {
            Renderer.iterateComponentTree(
                this.filterComponent,
                (c) => isPostRenderedComponent(c),
                (c) => (c as PostRenderedComponent).postRender(),
            );
            this.filterComponent.postRender();
        }
        this.status.isRendered = true;
        this.bindViewRemoval();

        window.addEventListener('resize', this.onWinsowResize);
        // @ts-ignore
        const resizeObserver = new ResizeObserver(
            this.debounce(
                () => {
                    if (OnVisibleRunner.isElementVisible(this.view)) {
                        this.refreshTableSize();
                    }
                }
                , 30)
        );
        resizeObserver.observe(this.view);
        return this.view;
    }

    private debounce = (func, delay) => {
        let inDebounce
        return function () {
            const context = this
            const args = arguments
            clearTimeout(inDebounce)
            inDebounce = setTimeout(() => func.apply(context, args), delay)
        }
    }
    private onWinsowResize = () => {
        if (!OnVisibleRunner.isElementVisible(this.view)) {
            OnVisibleRunner.add(this.view, this.refreshTableSize)
        }
    }

    private bindViewRemoval() {
        // Fully destroy the datatable when we remove it from de DOM.
        //
        // It is goog to destroy datatables because it adds a listener to the document and 
        // even if we remove it from the DOM and we don't need it anymore a reference to it is kept.
        // This may provoke a memory leak.
        //
        // In previous versions when a new page was stacked the bottom ones were saved out of the DOM
        // but currently we move them to another hiddden DOM element.
        const observer = new MutationObserver((mutations) => {
            // check for removed target
            if (!document.contains(this.view)) {
                observer.disconnect();
                this.dataTable?.destroy(true);
                window.removeEventListener('resize', this.onWinsowResize);
            }
        });

        const config = {
            childList: true,
            subtree: true,
            characterData: false,
            attributes: false,
        };
        observer.observe(document.body, config);
    }

    //#region Value related methods
    public value(data: TableData | TableUpdateData) {
        if (isTableUpdateData(data)) {
            // Can the form update the data of the table?
        } else {
            this.valueTableData(data as TableData);
        }
    }

    private valueTableData(data: TableData, isUpdate = false) {

        if (data != null && this.filterComponent != null) {
            if (isUpdate) {
                Renderer.instance().iterateToUpdateData(this.filterComponent, data.filter);
            } else {
                Renderer.instance().iterateToSetData(this.filterComponent, data.filter);
            }
        }
        if (data == null || (data.data == null && data.recordsTotal == null)) {
            this.autoInitValue();
            return;
        }
        if (data.recordsTotal == null && data.data != null) {
            data.recordsTotal = data.data.length;
        }
        this.status.reset();
        this.hideSorting(false, true);
        if (this.tableAdditionManager != null) {
            this.tableAdditionManager.reset();
        }
        this.view.querySelectorAll("table-check-header")
            .forEach((c) => (c as HeaderSelectCheckElement).status = "none-checked");

        let isTypeChanged = false;
        if (data.data != null && data.recordsTotal > data.data.length) {
            isTypeChanged = this.status.setServerType();
        } else {
            isTypeChanged = this.status.setClientType();
        }
        // If there is already a table keep the sorting and the scrolling position
        let order;
        let scrollPositionTop: number;
        if (this.dataTable != null) {

            order = this.dataTable.order();
            scrollPositionTop = $(this.dataTable.settings()[0].nScrollBody).scrollTop();

            if (isTypeChanged) {
                this.destroy();
            } else {
                this.dataTable.clear();
                (this.view.querySelector("table-check-info") as CheckInfoElement).info
                    = this.status.checkedInfo;
            }
        }
        // We use a reference in paginator to model, do not dereference it.
        this.model.setData(data);
        this.setNoValueMessage(data);
        if (this.dataTable == null) {
            this.initDatatable();
        }
        if (data != null) {
            if (data.data != null && this.status.isClientType()) {
                this.dataTable.clear();
                this.dataTable.rows.add(this.model.getAllRows());
            }
            TableFooter.setFooterValue(this.definition.footer, this.dataTable, this.model.footer);
            if (this.status.isRendered) {
                // Restore the order
                if (order != null) {
                    this.dataTable.order(order);
                }

                new OnVisibleRunner(this.view, () => {
                    this.dataTable.columns.adjust().draw();
                    (this.dataTable as any).scroller.measure();
                    // Restore the position
                    if (scrollPositionTop != null) {
                        $(this.dataTable.settings()[0].nScrollBody).scrollTop(scrollPositionTop);
                    }
                });
            }
            this.setCheckHeaderStatus(data);
        }
        this.checkActionsStatus();
        this.hideColumns();
    }

    private setNoValueMessage(data: TableData) {
        if ((data.data == null || data.data.length === 0) && this.definition.noEmptyMessage) {
            this.view.querySelector(".c-table__table")?.classList.add("no-empty-message");
        }
        if (data.data != null && data.data.length > 0 && this.definition.noEmptyMessage) {
            this.view.querySelector(".c-table__table")?.classList.remove("no-empty-message");
        }
    }

    private setCheckHeaderStatus(data) {
        let hidden = false;
        if (data.recordsTotal === 0 || this.status.disabled) {
            hidden = true;
        }
        this.view.querySelectorAll("table-check-header")
            .forEach((c) => (c as HeaderSelectCheckElement).setHidden(hidden));

        if (!hidden) {
            if (this.status.isServerType()) {
                this.view.querySelectorAll("table-check-header")
                    .forEach((c) => {
                        (c as HeaderSelectCheckElement).hiddenWithCriteria = true;
                    });
            } else {
                for (let index = 0; index < this.dataColumns.length; index++) {
                    const column = this.dataColumns[index];
                    if (isCheckColumnDefinition(column)) {
                        const c = this.dataTable.column(index).header().querySelector("table-check-header");
                        //If there are more than one, otherwise it make not sense to show the select all
                        const isCheckable = this.model.getSelectableRowsCount(index) > 1;
                        (c as HeaderSelectCheckElement).hiddenWithCriteria = !isCheckable;
                    }
                }
            }
        }
    }

    private hideColumns() {
        for (const column of this.restrictions.columnsToHide()) {
            const i = TableDefinitionUtils.getColumnIndexForProperty(column, this.definition);
            this.dataTable.column(i).visible(false);
        }
    }

    private destroy() {
        this.dataTable.clear().destroy();
        this.jqueryView.find("th").removeAttr("style");
        this.dataTable = null;
    }

    public updateData(data: any): void {
        if (isTableUpdateData(data)) {
            // Can the form update the data of the table?
        } else if (data == null) {
            this.refreshData();
        } else {
            this.valueTableData(data, true);
            this.fireTableDataRefreshed();
        }
    }

    private fireTableDataRefreshed() {
        const event = new CustomEvent("tableDataRefreshed", {
            bubbles: true,
        });
        this.view.dispatchEvent(event);
    }

    public setCommittedStatus(): void {
        fireDataChangedCleared(this.definition.id, this.view);
    }

    public appendData = (data: any): void => {
        if (Array.isArray(data)) {
            for (const d of data) {
                this.appendDataRow(d);
            }
        } else {
            this.appendDataRow(data);
        }
    }

    private appendDataRow = (data: any): void => {
        const newRow = TableDefinitionUtils.objectToRowData(this.definition, data);
        const key = this.rowKey.key(newRow);
        if (this.model.checkExistingKeyInModel(key, this.rowKey)) {
            message.show({
                level: "warn",
                key: "base.add.already_exists",
            });
            return;
        }

        this.tableAdditionManager = this.tableAdditionManager ?? new TableAdditionInline(this, this.view.querySelector("tfoot"), this.restrictionsDataModel);
        this.tableAdditionManager.addNewRow(newRow);
    }

    private refreshData(): void {
        this.status.reset();
        this.hideSorting(false, false);
        if (this.tableAdditionManager) {
            this.tableAdditionManager.reset();
        }
        this.view.querySelectorAll("table-check-header")
            .forEach((c) => (c as HeaderSelectCheckElement).status = "none-checked");
        (this.view.querySelector("table-check-info") as CheckInfoElement).info
            = this.status.checkedInfo;
        if (this.status.isClientType()) {
            this.autoInitValue();
        } else {
            this.model.empty();
            // console.log(
            //    "will reload " ,
            //     this.scrollPosition["scrollPosition"], (this.dataTable as any).scroller.page());
            this.dataTable.ajax.reload(() => {
                OnVisibleRunner.add(this.view, this.refreshTableSize)
            }
                , false);
            this.checkActionsStatus();
        }
    }

    private refreshTableSize = () => {
        if (this.dataTable == null) {
            return;
        }
        if (this.status.isClientType()) {
            // TODO reinitialize the able as client side
        }

        // if (this.model.)
        // console.log(
        //    "will draw ",
        //     this.scrollPosition["scrollPosition"],(this.dataTable as any).scroller.page());
        // https://datatables.net/forums/discussion/comment/152705/#Comment_152705
        this.dataTable.draw();
        // console.log(
        //  "will scroll " ,
        //  this.scrollPosition["scrollPosition"], (this.dataTable as any).scroller.page());
        this.scrollPosition.scrollToLastRow();
        // console.log(
        //  "has scrolled ",
        //   this.scrollPosition["scrollPosition"], (this.dataTable as any).scroller.page());
        TableFooter.setFooterValue(this.definition.footer, this.dataTable, this.model.footer);
    }

    public selectDataForAction(action: ActionDefinition) {
        return this.getTableValue(
            action.fieldParameterMappings,
            this.definition.submitsUnmodified || action.submitsUnmodified);
    }

    public getValue(): TableUpdateData {
        return this.getTableValue(null);
    }

    private getTableValue(mappings: FieldParameterMapping[], submitsUnmodified = null): TableUpdateData {
        const data: TableUpdateData = {
            data: {},
            modifications: [],
            additions: [],
            filterData: {},
            allCheckedColumns: {},
        };
        data["recordsTotal"] = this.model.recordsTotal || 0;

        for (const check of this.dataColumns.filter((c) => c.type === "CheckColumn")) {
            const checkedRows = this.status.checkedRows(check.property);
            data.data[check.property] = [];
            if (this.status.tracksUnchecked(check.property)) {
                data.allCheckedColumns[check.property] = true;
            } else {
                delete data.allCheckedColumns[check.property];
            }
            // tslint:disable-next-line: forin
            for (const checkedRowKey in checkedRows) {
                const rowData = checkedRows[checkedRowKey];
                const row = {};
                for (const idColumn of this.definition.idColumns) {
                    row[idColumn] = this.getValueForFieldInRow(idColumn, rowData);
                }

                // Explicit mappings
                if (mappings != null) {
                    for (const mapping of mappings) {
                        row[mapping.as] = this.getValueForFieldInRow(mapping.field, rowData);
                    }
                }
                data.data[check.property].push(row);
            }
        }
        if (this.status.changed && !submitsUnmodified) {
            for (const entry of this.status.getModifiedRows()) {
                data.modifications.push(this.model.getRow(entry));
            }
        }
        if (submitsUnmodified ?? this.definition.submitsUnmodified) {
            data.modifications = this.model.getAllRows();
        }
        data.additions = this.status.addedRows;
        if (this.filterComponent != null) {
            if (!isEqual(this.filterComponent.currentData, data.filterData)) {
                data.currentFilterData = { ...this.filterComponent.currentData };
                delete data.currentFilterData["_parent_"];
            }
            data.filterData = this.model.getFilterData();
            delete data.filterData["_parent_"];
            if (mappings != null) {
                for (const mapping of mappings) {
                    if (mapping.field.startsWith("filter.")) {
                        data[mapping.as] = this.filterComponent.currentData[mapping.field.substring(7)];
                    }
                }
            }
        }
        if (this.paginator == null && this.dataTable != null) {
            const order = [];
            const dtOrder = this.dataTable.order();
            for (const o of dtOrder) {
                const column = this.dataColumns[o[0]].property;
                const dir = o[1];
                order.push({
                    column,
                    dir,
                })
            }
            if (order.length > 0) {
                data.pagination = { order };
            }
        }
        if (this.paginator?.getCurrentSorting().length > 0) {
            data.pagination = { order: this.paginator.getCurrentSorting() };
        }
        if ((Object.keys(data.data).length === 0 || Object.keys(data.data).every((k) => data.data[k].length === 0))
            && (Object.keys(data.filterData).length === 0
                || Object.keys(data.filterData).every((k) => data.filterData[k] == null))
            && Object.keys(data.allCheckedColumns).length === 0
            && data.modifications.length === 0
            && data.additions.length === 0
            && data.pagination == null) {
            return null;
        }
        return data;
    }

    private overrideDefaultLanguagePropertiesDataTable(language: any) {
        //Override default empty message 
        if (this.definition.emptyMessage !== undefined
            && this.definition.emptyMessage !== null
            && this.definition.emptyMessage !== ''
            && !this.definition.noEmptyMessage) {
            language.sEmptyTable = i18n.instance.t(this.definition.emptyMessage);
        }
    }

    private initDatatable = () => {
        let language;
        try {
            language = require("./" + sislogUserGlobals.language + ".json");
        } catch (error) {
            language = require("./es.json");
        }

        this.overrideDefaultLanguagePropertiesDataTable(language);

        const options = {
            dom: "ti<\"checkedInfo\">",
            scrollY: this.definition.cssHeight ?? "40vh",
            scrollX: true,
            scrollCollapse: true,
            deferRender: true,
            scroller: {
                loadingIndicator: true,
            },
            addition: true,
            columnDefs: this.columnSettings,
            searching: false,
            order: [],
            language,
            serverSide: false,
            createdRow: this.createdRowClosure(this),
            initComplete: (settings, json) => {
                CheckInfoElement.appendInfoToTable(this.definition.columns, this.tableHolderView);
            },
        } as any;
        if (this.definition.fillContainer) {
            options.scrollResize = true;
        }
        if (this.definition.fixedColumns != null && this.model.recordsTotal !== 0) {
            (options as any).fixedColumns = {
                leftColumns: this.definition.fixedColumns,
            };
        }
        let isSorting = false;
        if (this.status.isServerType()) {
            let filterComponentDataObject;
            if (this.filterComponent == null) {
                filterComponentDataObject = {};
            } else {
                filterComponentDataObject = this.filterComponent.currentData;
            }
            this.paginator = new Paginator(
                this.model,
                this.getDataUrl(),
                filterComponentDataObject,
            );
            options.serverSide = true;
            options.ajax = this.paginator.paginate;
            options.scrollCollapse = false;
            options.drawCallback = (settings) => {
                if (isSorting) {
                    isSorting = false;
                    setTimeout(() => {
                        this.scrollPosition.scrollToLastRow();
                    }
                        , 0);
                }
            };
        }

        const tmpDtInitHolder = $('<div id="tmp-dt-init-holder" style="display:none">').appendTo("body");
        this.tableView.appendTo(tmpDtInitHolder);
        this.dataTable = this.tableView.DataTable(options);
        document["lastDatatable"] = this.dataTable;
        this.scrollPosition = new ScrollPosition(this.dataTable);
        if (this.paginator != null) {
            this.paginator.scrollPosition = this.scrollPosition;
            this.dataTable.on("order.dt", () => {
                isSorting = true;
                this.scrollPosition.freeze();
            });
        }
        // new ($.fn.dataTable as any).ColReorder(this.dataTable);
        const tableView = tmpDtInitHolder.children("div").detach();
        tableView.appendTo(this.tableHolderView);
        tmpDtInitHolder.remove();
        this.status.isCreated = true;
        tableView.find(".dataTables_scrollBody").on("scroll", this.scrollPosition.storePositionOnScroll);
    }

    private additionDataChangedCallback = (evt: CustomEvent<AdditionDataChangedEventDetail>) => {
        const evtDetail = evt.detail;
        this.status.changed = true;
        this.status.addedRows = evtDetail.model;
        this.status.addedRowsValid = evtDetail.valid;
        this.checkActionsStatus();
        fireDataChangedEvent(this, this.view, this.getValue(), undefined, this.status.isValid());
        evt.stopPropagation();
    }

    private hideSorting(hide: boolean, resetToLast: boolean): void {
        if (hide) {
            $(this.view).find("th.sorting").css("pointer-events", "none");
            this.view.querySelector(".c-table__table")?.classList.add("c-table__table-editing");
        } else {
            $(this.view).find("th.sorting").css("pointer-events", "initial");
            this.view.querySelector(".c-table__table")?.classList.remove("c-table__table-editing");
            if (resetToLast) {
                $(this.view).find("th.sorting").removeClass("sorting_asc sorting_desc");
            }
        }
    }

    private dataChangedCallback = (evt: CustomEvent<DataChangedEventDetail>) => {
        const evtDetail = evt.detail;
        evt.stopPropagation();
        this.status.changed = true;
        // Disable sorting
        this.hideSorting(true, false);
        const cell = this.getCellFromEvt(evt);
        const modelRowindex = this.getRowIndexFromCell(cell);
        const columnIndex = this.dataTable.cell(cell).index().column;
        this.model.setCell(modelRowindex, columnIndex, evtDetail.data);

        this.restrictions.applyDependenciesToRow(
            this.componentCells,
            cell[0],
            this.model.getRow(modelRowindex),
            this.restrictionsDataModel
        );
        this.validate(modelRowindex, cell);
        this.checkActionsStatus();
        // DO  not dispatch change event if change is for initialization
        if (!evt.detail.initializationChange) {
            this.status.addModifiedRow(modelRowindex);
            fireDataChangedEvent(this, this.view, this.getValue(), undefined, this.status.isValid());
        }
        evt.stopPropagation();
    }

    private dataChangeRequestCallback = (event: CustomEvent) => {
        const suggestion = event.detail;
        const cell = this.getCellFromEvt(event);
        const tableRowIndex = this.dataTable.cell(cell).index().row;

        const modelRowIndex = this.getRowIndexFromCell(cell);

        const dataArray = TableDefinitionUtils.objectToRowData(this.definition, suggestion.data);

        for (let index = 0; index < dataArray.length; index++) {
            const element = dataArray[index];
            if (element !== undefined) {
                this.model.setCell(modelRowIndex, index, element);
                if (isComponentColumnDefinition(this.dataColumns[index])) {
                    this.componentCells.get(cell[0].firstChild).value(element)
                } else {
                    this.dataTable.cell(tableRowIndex, index).data(element);
                }
            }
        }
        this.dataTable.draw();
        fireDataChangedEvent(event.detail.component, event.detail.component.view, event.detail.component.getValue());
    }

    private tableDataUpdateRequestedCallback = (event: CustomEvent) => {
        const data = event.detail.data;
        if (data["__table-external-edit-action__"] === "create") {
            this.appendData(data);
        }
    }

    // private getRowModelAsObject = (rowData) => {
    //     return TableDefinitionUtils.rowDataToObject(this.definition, rowData);
    // }

    /**
     * To be used by a form to apply the restictions
     * @param currentData The data model of the form
     */
    public applyDependenciesFromHolder(currentData: {}) {
        const table = this;

        table.restrictionsDataModel.parentData = currentData;
        table.restrictions.applyDependenciesToFilter(this.filterComponent, this.restrictionsDataModel);
        // for each row
        this.dataTable?.rows().every(
            function (rowIdx, tableLoop, rowLoop) {
                const e = (this.node() as Element);
                // we check the table.model.length because the table can be refreshing and
                // the model can be empty despite it is showing previous rows
                if (e != null && table.model.length > 0) {
                    // merge row model with parent model
                    // validate row
                    table.restrictions.applyDependenciesToRow(
                        table.componentCells,
                        e.firstElementChild,
                        table.model.getRow(rowIdx),
                        table.restrictionsDataModel);
                }
            },
        );

        this.tableAdditionManager?.applyDependenciesToNewRows();
    }

    private getDataUrl(): string {
        if (this.filterComponent == null || this.definition.dataUrl != null) {
            return appModuleRegistry.prefixUrl(this.definition.dataUrl);
        } else {
            const buttonDefinition = (this.definition.filter.actions[0] as ActionButtonDefinition);
            const actionDefinition = buttonDefinition.action;
            if (isServerActionDefinition(actionDefinition)) {
                return appModuleRegistry.prefixUrl(actionDefinition.url);
            }
            return null;
        }
    }

    private getRowIndexFromCell(cell) {
        if (this.status.isClientType()) {
            return this.dataTable.cell(cell).index().row;
        } else {
            return this.dataTable.cell(cell).index().row + this.dataTable.page.info().start;
        }
    }

    public getCellFromEvt(evt) {
        return $(evt.target).closest("td");
    }

    private prepareColumnOptions(definition: TableDefinition) {
        const columnSettings = [];
        $.each(this.dataColumns, (key, val) => {
            const c = ColumnFactory.column(key, val, this);
            columnSettings.push(c);
        });
        this.columnSettings = columnSettings;
    }

    private createdRowClosure(tableComponent: Table) {
        this.componentCells = this.componentCells ?? new ComponentCells();
        function createdRowCallback(row, rowData: any[], rowIndex: number) {
            let modelRowindex = rowIndex;
            if (!tableComponent.status.isClientType()) {
                modelRowindex = rowIndex + this.api().page.info().start;
            }
            let isAnyComponent = false;
            for (let index = 0; index < tableComponent.dataColumns.length; index++) {
                const cd = tableComponent.dataColumns[index] as ColumnDefinition;
                tableComponent.applyRowStyleOnCheck(cd, row, modelRowindex, tableComponent);
                if (isComponentColumnDefinition(cd)) {
                    tableComponent.componentCells.renderComponentCell(
                        tableComponent,
                        tableComponent.columnOptions,
                        cd,
                        row,
                        rowData,
                        modelRowindex,
                        index,
                    );
                    isAnyComponent = true;
                }
            }
            if (isAnyComponent) {
                tableComponent.validateModel(rowData, rowIndex, modelRowindex, this.api());
                tableComponent.restrictions.applyDependenciesToRow(
                    tableComponent.componentCells,
                    row,
                    rowData,
                    tableComponent.restrictionsDataModel);
            }
            if (tableComponent.definition.rowStyleProperty != null) {
                $(row).addClass("c-table__row--"
                    + tableComponent.getValueForFieldInRow(tableComponent.definition.rowStyleProperty, rowData));
            }
        }
        return createdRowCallback;
    }

    private applyRowStyleOnCheck(cd: ColumnDefinition, row, rowIndex: number, component: Table): void {
        if (isCheckColumnDefinition(cd) && cd.rowStyle != null) {
            const rowKey = component.getRowKey(rowIndex);
            if (component.status.isChecked(cd.property, rowKey)) {
                $(row).addClass("c-table__row--" + cd.rowStyle);
            }
        }
    }

    public autoInitValue(): void {
        let actionDefinition: ActionDefinition;
        let data: {};
        if (this.filterComponent == null
            || this.definition.filter.actions == null
            || this.definition.filter.actions.length === 0) {

            actionDefinition = {
                actionName: "filter",
                needsChange: false,
                needsValid: false,
                url: this.definition.dataUrl,
                httpMethod: "get",
            } as ServerActionDefinition;
        } else {
            const buttonDefinition = (this.definition.filter.actions[0] as ActionButtonDefinition);
            actionDefinition = buttonDefinition.action;
        }
        if (this.filterComponent != null) {
            data = this.filterComponent.selectDataForAction(actionDefinition);
            delete data["_parent_"];
        }
        new Action(actionDefinition, this).run(data, this);
    }
    //#endregion

    //#region Validation and restriction methods
    public applyRestrictions(restrictions: TableRestrictions): void {
        if (restrictions.filter != null) {
            Renderer.instance().iterateToSetRestrictions(this.filterComponent, restrictions.filter);
        }
        this.applyRestriciontsToColumns(restrictions);
        this.restrictionsDataModel.filterData = this.filterComponent?.currentData;
        this.restrictions.applyRestriciontsToActions(restrictions, this.definition.actions);
        this.restrictions.applyRestriciontsToButtons(restrictions, this.getButtons());
        if (restrictions.attributes != null
            && restrictions.attributes[0] === RestrictionAttribute.readonly) {
            this.setReadOnly(true);
        }
    }

    private applyRestriciontsToColumns(restrictions: TableRestrictions) {
        this.restrictions.init(restrictions, this);
    }

    private validate(modelRowindex: number, cell: JQuery) {
        const dtRowIndex = this.dataTable.cell(cell).index().row;
        this.validateModel(this.model.getRow(modelRowindex), dtRowIndex, modelRowindex, this.dataTable);
    }

    private validateModel(rowData: any[], dtRowIndex: number, modelRowIndex: number, dataTable: DataTables.Api) {
        const validate = require("validate.js");
        const currentData = {};
        for (let index = 0; index < this.dataColumns.length; index++) {
            const column = this.dataColumns[index];
            if (column.property != null) {
                currentData[column.property] = rowData[index];
            }
        }
        let validationResult = validate(currentData, this.restrictions.columnConstraints, { fullMessages: false });
        if (validationResult == null) {
            validationResult = {};
        }

        for (let index = 0; index < this.dataColumns.length; index++) {
            const column = this.dataColumns[index];
            if (isComponentColumnDefinition(column)) {
                const c = dataTable.cell(dtRowIndex, index);
                const htmlElement = (c.node() as Element).firstElementChild;
                const component = this.componentCells.get(htmlElement);
                if (component != null) {
                    if (isValidationStatusComponent(component)) {
                        if (validationResult[column.property] == null) {
                            component.setValidationStatus(true);
                        } else {
                            component.setValidationStatus(false, validationResult[column.property]);
                        }
                    }
                }
            }
        }
        const key = this.getRowKey(modelRowIndex);
        this.status.setValid(
            key,
            modelRowIndex,
            Object.keys(validationResult).length === 0,
        );
    }

    private getRowKey(rowindex: number): string {
        if (this.rowKey == null) {
            return rowindex.toString();
        } else {
            return this.rowKey.key(this.model.getRow(rowindex));
        }
    }
    //#endregion


    //#region Options methods
    public setOptions(options: TableOptions): void {
        // For now just for the filter
        if (options.filter != null && this.filterComponent != null) {
            Renderer.instance().iterateToSetOptions(this.filterComponent, options.filter);
        }
    }

    public addOptions(options: TableOptions): void {
        if (options == null) {
            return;
        }
        this.addOptionsToFilter(options.filter);
        this.addOptionsToActions(options.actions);
        this.addOptionsToColumns(options.columns);
    }

    private addOptionsToColumns(options: Dictionary<Array<Option | Optgroup>>): void {
        this.columnOptions = options;
        this.tableAdditionManager?.setOptions(options);
    }

    private addOptionsToFilter(filterOptions: Dictionary<Array<Option | Optgroup>>): void {
        if (filterOptions != null && this.filterComponent != null) {
            Renderer.instance().iterateToAddOptions(this.filterComponent, filterOptions);
        }
    }

    private addOptionsToActions(actionOptions: Dictionary<Dictionary<Array<Option | Optgroup>>>): void {
        if (actionOptions != null) {
            for (const actionOptionKey in actionOptions) {
                if (actionOptions.hasOwnProperty(actionOptionKey)) {
                    for (const actionButton of this.definition.actions) {
                        if (actionOptionKey === actionButton.action.actionName) {
                            if (isParameterizedActionDefinition(actionButton.action)) {
                                actionButton.action.parametersForm.options = actionOptions[actionOptionKey];
                            }
                        }
                    }
                }
            }
        }
    }
    //#endregion

    public getView() {
        return this.view;
    }

    public unhide(): void {
        this.scrollPosition.scrollToLast();
        for (const b of this.getButtons()) {
            b.unhide();
        }
        this.filterComponent?.unhide();
    }

    public setReadOnly(ro: boolean, targetColumn: string = null) {
        if (targetColumn == null) {
            this.status.disabled = ro;
            // Do it for every column
            this.setReadOnlyColumn(ro, "table-check");
            this.componentCells?.setAllReadOnly(this.tableView[0], ro);
            this.tableAdditionManager?.setReadOnly(ro);
        } else {
            this.status.disabledColumns = this.status.disabledColumns ?? {};
            this.status.disabledColumns[targetColumn] = ro;
            this.setReadOnlyColumn(ro, targetColumn);
        }
    }
    private setReadOnlyColumn(ro: boolean, targetColumn: string = null) {
        this.restrictions.setReadOnlyColumn(ro, targetColumn);
        if (this.dataTable == null) {
            return;
        }
        const idx = TableDefinitionUtils.getColumnIndexForProperty(targetColumn, this.definition);
        const column = this.dataTable.column(idx);
        this.setReadOnlyHeaderSelect(ro, column, idx);

        (column.nodes() as any).each((n) => {
            const data = this.dataTable.cell(n).data() as boolean;
            const node = n.querySelector("input");
            if (node != null) {
                if (ro) {
                    node.disabled = true;
                } else {
                    node.disabled = false || !data;
                }
            }
        });
    }

    private setReadOnlyHeaderSelect(ro: boolean, column, idx) {
        const c = column.header().querySelector("table-check-header");
        const isCheckacble = this.model?.getSelectableRowsCount(idx) > 0;
        if (isCheckacble && c != null && this.status.isClientType()) {
            (c as HeaderSelectCheckElement).hiddenWithCriteria = ro;
        }
    }

    public getNestedComponents(): Component[] {
        const nested = [];
        if (this.filterComponent != null) {
            nested.push(this.filterComponent);
        }
        if (this.buttonBar != null) {
            nested.push(this.buttonBar);
        }
        return nested;
    }
}

export interface TableDefinition extends BaseTableDefinition, ActionComponentDefinition {
    exportConfigurations?: ExportConfiguration[];
    actions?: ActionButtonDefinition[];
    collapseFilterAfterSearch?: boolean;
    noEmptyMessage?: boolean;
    emptyMessage?: string;
    preventLoss?: boolean;
    submitsUnmodified?: boolean;
    rowStyleProperty?: string;
}

export interface BaseTableDefinition extends BindableComponentDefinition {
    columns: ColumnDefinition[];
    extraFields?: string[];
    idColumns?: string[];
    filter?: FormDefinition;
    footer?: FooterCellDefinition[];
    dataUrl?: string;
    dataUrlBaseExport?: string;
    allowsInsert?: boolean;
    actionDeleteRows: ActionDefinition[];
    fixedColumns?: number;
    cssHeight?: string;
    fillContainer?: boolean;
}

export interface TableData {
    draw: number;
    recordsTotal: number;
    data: any[];
    filter: any;
    footer: any;
}

export function isTable(component: Component): component is Table {
    return component.componentType === "table";
}

export interface TableRestrictionApplicable {
    applyRestrictions(restrictions: TableRestrictions): void;
}

export function isTableRestrictionApplicable(component: any): component is TableRestrictionApplicable {
    return component != null && component.applyRestrictions != null && component.applyRestrictions instanceof Function;
}

